<ng-template #associateAsset let-modal>
  <form [formGroup]="formGroup">
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <h3>{{ "ASSOCIATE" | translate }}</h3>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label class="col-form-label">{{ "TITLES.USERS_TYPES_SINGULAR.employee" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select
              bindLabel="complete_name"
              bindValue="hash"
              class="{{ fieldHasErrors('employee') ? 'is-invalid' : '' }}"
              [searchable]="true"
              [closeOnSelect]="true"
              [clearable]="false"
              [openOnEnter]="false"
              [virtualScroll]="true"
              [items]="employees"
              formControlName="employee"
              [readonly]="isFromFutureEmployeeList"
            >
            </ng-select>
            <div class="invalid-feedback" *ngIf="formGroup.controls.employee.errors?.required">{{ "ERRORS.SELECT_DESTINATORY" | translate }}</div>
          </div>
        </div>
        <!--Input visualizzabile soltanto se la modal viene aperta da futuri dipendenti lista-->
        <div class="col-6" *ngIf="isFromFutureEmployeeList">
          <div class="form-group">
            <label class="col-form-label">{{ "ASSETS" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select bindLabel="name" bindValue="id" [searchable]="true" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" [items]="assetList" formControlName="assetId">
            </ng-select>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label class="col-form-label">{{ "FROM" | translate }}<sup class="text-danger">*</sup></label>
            <ng2-flatpickr [config]="basicDateSend" formControlName="date"></ng2-flatpickr>
          </div>
        </div>

        <div class="col-{{ isFromFutureEmployeeList ? '6' : '12' }}">
          <div class="form-group">
            <label class="col-form-label">{{ "LOCATION" | translate }}</label>
            <input type="text" class="form-control" formControlName="location" />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label class="col-form-label">{{ "NOTES" | translate }}</label>
            <textarea name="description" class="form-control" formControlName="description"></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="button" class="btn btn-outline-primary w-150" (click)="closeModal()" rippleEffect>
        {{ "CANCEL" | translate }}
      </button>
      <button type="submit" (click)="saveAssociate()" class="btn btn-primary w-150" rippleEffect>
        {{ "SEND" | translate }}
      </button>
    </div>
  </form>
</ng-template>
